module.exports = __webpack_public_path__ + "static/media/Sec-1-Background-Mobile.e5f6dde4.webp";